import { getUser } from '@/api/api';

export const APP_ADMIN_ROLE = 'app-admin';

interface AccessTokenClaims {
  // biome-ignore lint/style/useNamingConvention: Keycloak claim name
  realm_access?: { roles?: string[] };
}

/** Decode the base64url payload of a JWT without verifying it (roles are only used for UI gating). */
const decodeJwtPayload = (token: string): AccessTokenClaims | null => {
  const payload = token.split('.')[1];
  if (!payload) return null;
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      Array.from(atob(base64))
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );
    return JSON.parse(json) as AccessTokenClaims;
  } catch {
    return null;
  }
};

/** Realm roles of the currently signed-in user (empty when not signed in). */
export const getUserRoles = (): string[] => {
  const user = getUser();
  if (!user?.access_token) return [];
  return decodeJwtPayload(user.access_token)?.realm_access?.roles ?? [];
};

export const hasRole = (role: string): boolean => getUserRoles().includes(role);
